/* Core */
import { createRoot } from 'react-dom/client';
import { InertiaApp } from '@inertiajs/inertia-react';
import { InertiaProgress } from '@inertiajs/progress';
import * as Sentry from '@sentry/browser';

/* Real time data */
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

/* Providers */
import { ThemeProvider } from './Shared/Theme';
import { WebsocketProvider } from './Shared/Websocket';

/* Icons */
import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faTimes,
	faBoxesStacked,
	faWrench,
	faSlidersH,
	faTachometerAlt,
	faThumbsUp,
	faThumbsDown,
	faNetworkWired,
	faPlus,
	faTerminal,
	faHandPointRight,
	faHandPointUp,
	faHandPointDown,
	faExclamationCircle,
	faSort,
	faSortUp,
	faSortDown,
	faFile,
	faDatabase,
	faUser,
	faTachometerFast,
	faPrint,
	faUserShield,
	faChevronDown,
	faChevronRight,
} from '@fortawesome/free-solid-svg-icons';

library.add(
	faTimes,
	faBoxesStacked,
	faWrench,
	faSlidersH,
	faTachometerAlt,
	faThumbsUp,
	faThumbsDown,
	faNetworkWired,
	faPlus,
	faTerminal,
	faHandPointRight,
	faHandPointUp,
	faHandPointDown,
	faExclamationCircle,
	faSort,
	faSortUp,
	faSortDown,
	faFile,
	faDatabase,
	faUser,
	faTachometerFast,
	faPrint,
	faUserShield,
	faChevronDown,
	faChevronRight,
);

InertiaProgress.init({
	color: '#ED8936',
	showSpinner: true,
});

Sentry.init({
	dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
});

const app = document.getElementById('app');
const root = createRoot(app);

root.render(
	<WebsocketProvider>
		<ThemeProvider>
			<InertiaApp
				initialPage={JSON.parse(app.dataset.page)}
				resolveComponent={(name) =>
					import(`./Pages/${name}`).then((module) => module.default)
				}
			/>
		</ThemeProvider>
	</WebsocketProvider>,
);
